import React from 'react';

interface ScanlineOverlayProps {
  className?: string;
  /** 0–1 scanline opacity */
  intensity?: number;
  vignette?: boolean;
}

/** CRT scanlines — shared by boot screen and optional desktop overlay. */
export const ScanlineOverlay: React.FC<ScanlineOverlayProps> = ({
  className = '',
  intensity = 0.08,
  vignette = false,
}) => (
  <div className={`absolute inset-0 pointer-events-none ${className}`} aria-hidden>
    <div
      className="absolute inset-0"
      style={{
        opacity: intensity,
        backgroundImage: `repeating-linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.18) 0px,
          rgba(0, 0, 0, 0.18) 1px,
          transparent 1px,
          transparent 2px
        )`,
      }}
    />
    {vignette && (
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.55) 100%)',
        }}
      />
    )}
  </div>
);

export default ScanlineOverlay;
